import React, { useState, useEffect } from "react";
import "./JoinCreatorForm.css";
import logoImage from "../../assets/images/AstrocureLogo.svg";
import SuccessImg from "../../assets/images/Success_img.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { showToast } from "../../utils/toastUtils";
import Header from "../../Components/Header/Header";
import { callApi } from "../../utils/apiService";
import Select from "react-select";
import { videoCreatorEndPoint, webEndPoint } from "../../Constants/constants";
import { useUser } from "../../Context/UserContext";

const OtpModal = ({
  type,
  value,
  onVerify,
  onClose,
  setOtpError,
  otpError,
  onResend,
  resending,
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [emailOtp, setEmailOtp] = useState("");
  const [timer, setTimer] = useState(60);

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "");

    const newOtp = [...otp];
    newOtp[index] = val;

    // If a digit was entered, update and move forward
    if (val) {
      setOtp(newOtp);
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
      return;
    }

    // If cleared (including mobile clear 'x'), clear previous digit too and move focus back
    const prev = e.target.previousElementSibling;
    if (prev && index > 0) {
      newOtp[index - 1] = "";
      setOtp(newOtp);
      prev.focus();
      return;
    }

    // Default: just update state
    setOtp(newOtp);
  };

  useEffect(() => {
    const id = setInterval(() => {
      setTimer((t) => (t > 0 ? t - 1 : 0));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const handleResend = () => {
    if (timer > 0 || resending) return;
    setOtpError("");
    setOtp(["", "", "", "", "", ""]);
    setEmailOtp("");
    onResend(); // calls the send-otp API again
    setTimer(60); // restart the countdown
  };

  const handleEmailOtpChange = (e) => {
    const val = e.target.value.replace(/\D/, "");
    setEmailOtp(val);
  };

  const handleVerify = () => {
    if (type === "mobile number") {
      if (otp.join("").length !== 6) {
        setOtpError("Please enter complete OTP");
        return;
      }
    } else if (type === "email id") {
      if (emailOtp.length !== 6) {
        setOtpError("Please enter complete OTP");
        return;
      }
    }

    setOtpError("");
    onVerify(type === "mobile number" ? otp.join("") : emailOtp);
  };

  return (
    <div className="jc-modal-overlay">
      <div className="jc-otp-modal">
        <img src={logoImage} alt="AstroCure" className="verify-logo-image" />
        <h2
          className={`jc-${type === "mobile number" ? "mobile" : "email"}-modal-title`}
        >
          Verify your {type} to continue
        </h2>
        {type == "mobile number" && (
          <p className="jc-mobile-modal-text">
            We'll send a one-time password OTP to your {type}{" "}
            <span>
              {type == "mobile number" && "+91 "}
              {type == "mobile number"
                ? `${value.slice(0, 5)} ${value.slice(5)}`
                : value}
            </span>{" "}
            to confirm it’s you.{" "}
          </p>
        )}
        {type == "email id" && (
          <p className="jc-email-modal-text">
            Please check your inbox for the verification code sent to{" "}
            <span>{value}</span>{" "}
          </p>
        )}
        {type == "mobile number" && (
          <div className="jc-otp-box">
            {otp.map((digit, index) => (
              <input
                key={index}
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => {
                  // If backspace is pressed on an empty box, move focus to previous and clear it
                  if (e.key === "Backspace") {
                    if (otp[index]) {
                      // let onChange handle clearing this box
                      return;
                    }

                    const prev = e.target.previousElementSibling;
                    if (prev) {
                      const newOtp = [...otp];
                      newOtp[index - 1] = "";
                      setOtp(newOtp);
                      prev.focus();
                      // prevent default to avoid browser navigating back
                      e.preventDefault();
                    }
                  }
                }}
              />
            ))}
          </div>
        )}
        {type == "email id" && (
          <div className="jc-email-box">
            <input
              value={emailOtp}
              onChange={handleEmailOtpChange}
              maxLength={6}
              placeholder="Enter the 6-digit code here"
            />
          </div>
        )}
        {otpError && <p className="jc-error">{otpError}</p>}

        {timer > 0 && <p className="jc-timer">{timer} sec</p>}

        <button
          className="jc-verify-code-button"
          onClick={handleVerify}
          disabled={
            type === "mobile number"
              ? otp.join("").length !== 6
              : emailOtp.length !== 6
          }
        >
          Verify OTP
        </button>
        {type === "mobile number" && (
          <p className="find-text">Can’t find the OTP? Resend it again.</p>
        )}
        {type === "email id" && (
          <p className="find-text">
            Can’t find it ? Please check your spam folder
          </p>
        )}

        <button
          className="jc-back-button"
          onClick={handleResend}
          disabled={resending}
        >
          Resend OTP
        </button>

        <button className="jc-close" onClick={onClose}>
          ✕
        </button>
      </div>
    </div>
  );
};

const SuccessModal = ({
  SuccessMsg = "",
  message = "",
  onClose,
  notifyMsg = "",
  btnName = "",
}) => {
  return (
    <div className="jc-modal-overlay">
      <div className="jc-success-modal">
        <img src={SuccessImg} alt="AstroCure" className="verify-logo-image" />
        <h3 className="jc-successMsg">{SuccessMsg}</h3>
        <h3 className="jc-successDesc">{message}</h3>
        <h3 className="jc-success-Desc">{notifyMsg}</h3>
        <button className="jc-verify-btn-success" onClick={onClose}>
          {btnName}
        </button>
      </div>
    </div>
  );
};

const Loader = () => (
  <div className="jc-loader-overlay">
    <div className="jc-loader"></div>
  </div>
);

/* ================= MAIN COMPONENT ================= */

const JoinCreatorForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    email: "",
    password: "",
    languages: [],
    youtubeLink: "",
    instagramLink: "",
  });

  // const [languages, setLanguages] = useState([]);
  const [loadingLanguages, setLoadingLanguages] = useState(false);
  const [errors, setErrors] = useState({});
  const [showOtp, setShowOtp] = useState(null); // mobile | email
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [successDesc, setSuccessDesc] = useState("");
  const [notifyMsg, setNotifymsg] = useState("");
  const [btnName, setBtnName] = useState("");
  const [otpError, setOtpError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sendingMobileOtp, setSendingMobileOtp] = useState(false);
  const [sendingEmailOtp, setSendingEmailOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [verificationToken, setVerificationToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const { languages } = useUser();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleLanguageChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    setFormData((prev) => ({
      ...prev,
      languages: selectedIds,
    }));

    setErrors((prev) => ({
      ...prev,
      languageId: "",
    }));
  };

  const languageOptions = languages.map((lang) => ({
    value: lang.id,
    label: lang.dataName,
  }));
  const selectedLanguages = languageOptions.filter((option) =>
    formData.languages.includes(option.value),
  );

  // Transform languages for react-select

  const validate = () => {
    let newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required";

    if (!formData.mobileNumber.trim())
      newErrors.mobileNumber = "Mobile Number is required";
    else if (!/^[0-9]{10}$/.test(formData.mobileNumber.trim()))
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number";
    else if (!mobileVerified)
      newErrors.mobileNumber = "Please verify mobile number";

    if (!formData.email.trim()) newErrors.email = "Email Address is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email address";
    else if (!emailVerified) newErrors.email = "Please verify email";

    if (!formData.password) newErrors.password = "Password is required";
    if (!formData.languages?.length)
      newErrors.languageId = "Languages Known are required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      fullName: formData.fullName,
      mobileNumber: formData.mobileNumber,
      email: formData.email,
      password: formData.password,
      languages: formData.languages,
    };

    try {
      setSubmitting(true);

      const response = await callApi(
        `${videoCreatorEndPoint}auth/signup`,
        "POST",
        payload,
        {
          Authorization: `Bearer ${verificationToken}`,
        },
      );

      console.log("Signup Success:", response);

      setSuccessMessage("Creator Form Submitted Successfully");
      setSuccessDesc(
        "Thanks for applying! Your creator application is under review.",
      );
      setNotifymsg("We'll notify you once it's complete.");
      setBtnName("welcome");
    } catch (error) {
      showToast(
        "error",
        error?.message ||
          "Something went wrong while submitting the application",
      );

      setErrors((prev) => ({
        ...prev,
        api:
          error?.message ||
          "Something went wrong while submitting the application",
      }));
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSuccessMessage("");

    if (btnName === "welcome") {
      navigate("/dashboard");
    }
  };

  const handleMobileVerification = async () => {
    try {
      setSendingMobileOtp(true);

      const payload = {
        mobileNumber: formData.mobileNumber,
      };

      const response = await callApi(
        `${videoCreatorEndPoint}auth/mobile-verification-otp`,
        "POST",
        payload,
      );

      console.log("Mobile OTP Sent:", response);

      // OTP sent successfully - show toast and only now open the modal
      showToast(
        "success",
        response?.alert || "OTP sent successfully to your mobile number",
        100,
      );
      setOtpError("");
      setShowOtp("mobile");
    } catch (error) {
      console.error("Mobile OTP Error:", error);

      // Error from response - show toast, do NOT open the modal
      showToast("error", error?.message || "Failed to send OTP. Please try again.");
    } finally {
      setSendingMobileOtp(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("verificationToken");

    if (token) {
      setVerificationToken(token);
    }
  }, []);

  const verifyMobileOtp = async (otpCode) => {
    try {
      setVerifyingOtp(true);

      const payload = {
        mobileNumber: formData.mobileNumber,
        otp_code: otpCode,
      };

      const response = await callApi(
        `${videoCreatorEndPoint}auth/verify-mobile-otp`,
        "POST",
        payload,
      );

      console.log("Mobile OTP Verified:", response);

      const token = response?.data?.verificationToken;

      setVerificationToken(token);

      localStorage.setItem("verificationToken", token);
      setMobileVerified(true);

      setErrors((prev) => ({
        ...prev,
        mobileNumber: "",
      }));

      setShowOtp(null);
      setSuccessMessage("Verification successful");
      setSuccessDesc("Your mobile number has been verified successfully.");
      setNotifymsg("");
      setBtnName("Continue");
    } catch (error) {
      console.error(error);
      showToast("error", error?.message || "Invalid OTP. Please try again.");

      // setOtpError(error?.message || "Invalid OTP. Please try again.");
    } finally {
      setVerifyingOtp(false);
    }
  };
  const handleEmailVerification = async () => {
    try {
      setSendingEmailOtp(true);

      const payload = {
        email: formData.email,
        mobileNumber: formData.mobileNumber,
      };
      const response = await callApi(
        `${videoCreatorEndPoint}auth/email-verification-otp`,
        "POST",
        payload,
        {
          Authorization: `Bearer ${verificationToken}`,
        },
      );

      console.log("Email OTP Sent:", response);

      // OTP sent successfully - show toast and only now open the modal
      showToast(
        "success",
        response?.alert || "OTP sent successfully to your email address",
        100,
      );
      setOtpError("");
      setShowOtp("email");
    } catch (error) {
      console.error("Email OTP Error:", error);

      // Error from response - show toast, do NOT open the modal
      showToast(
        "error",
        error?.message || "Failed to send email OTP. Please try again.",
      );
    } finally {
      setSendingEmailOtp(false);
    }
  };

  const verifyEmailOtp = async (otpCode) => {
    try {
      setVerifyingOtp(true);

      const payload = {
        email: formData.email,
        mobileNumber: formData.mobileNumber,
        otp_code: otpCode,
      };

      const response = await callApi(
        `${videoCreatorEndPoint}auth/verify-email-otp`,
        "POST",
        payload,
        {
          Authorization: `Bearer ${verificationToken}`,
        },
      );

      console.log("Email OTP Verified:", response);
      const token = response?.data?.verificationToken;

      setVerificationToken(token);

      localStorage.setItem("verificationToken", token);

      setEmailVerified(true);

      setErrors((prev) => ({
        ...prev,
        email: "",
      }));

      setShowOtp(null);
      setSuccessMessage("Verification successful");
      setSuccessDesc("Your email address has been verified successfully.");
      setNotifymsg("");
      setBtnName("Continue");
    } catch (error) {
      console.error(error);
      showToast("error", error?.message || "Invalid OTP. Please try again.");
      // setOtpError(error?.message || "Invalid OTP. Please try again.");
    } finally {
      setVerifyingOtp(false);
    }
  };
  return (
    <>
      <Header />
      <div className="jc-page">
        <div className="jc-card">
          <h1 className="jc-title">Join as a Creator</h1>
          <p className="jc-subtitle">
            Join AstroCure and share your astrological insights with a AstroCure
            audience.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            {/* Full Name */}
            <h2 className="jc-section-title">Basic Details</h2>

            <div className="jc-field">
              <label className="jc-label">
                Full Name <span className="jc-required">*</span>
              </label>
              <input
                className={`jc-input ${errors.fullName ? "jc-input-error" : ""}`}
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
              />
              {errors.fullName && <p className="jc-error">{errors.fullName}</p>}
            </div>

            {/* Mobile */}
            <div className="jc-field">
              <label className="jc-label">
                Mobile Number <span className="jc-required">*</span>
              </label>

              <input
                className={`jc-input ${errors.mobileNumber ? "jc-input-error" : ""}`}
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                maxLength={10}
                placeholder="Enter your Mobile Number"
              />
              {mobileVerified && (
                <p className="jc-verified">Mobile number verified</p>
              )}

              {errors.mobileNumber && (
                <p className="jc-error">{errors.mobileNumber}</p>
              )}
              {!!/^[0-9]{10}$/.test(formData.mobileNumber) &&
                !mobileVerified && (
                  <div className="jc-verify-wrapper">
                    <button
                      type="button"
                      className="jc-verify-btn"
                      disabled={
                        !/^[0-9]{10}$/.test(formData.mobileNumber) ||
                        sendingMobileOtp
                      }
                      onClick={handleMobileVerification}
                    >
                      Verify Mobile Number
                    </button>
                  </div>
                )}
            </div>

            {/* Email */}
            <div className="jc-field">
              <label className="jc-label">
                Email Address <span className="jc-required">*</span>
              </label>

              <input
                className={`jc-input ${errors.email ? "jc-input-error" : ""}`}
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your Email Address"
              />
              {emailVerified && (
                <p className="jc-verified">Email Address verified</p>
              )}

              {errors.email && <p className="jc-error">{errors.email}</p>}
              {!!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) &&
                mobileVerified &&
                !emailVerified && (
                  <div className="jc-verify-wrapper">
                    <button
                      type="button"
                      className="jc-verify-btn"
                      onClick={handleEmailVerification}
                      disabled={
                        !mobileVerified ||
                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ||
                        sendingEmailOtp
                      }
                    >
                      Verify Email ID
                    </button>
                  </div>
                )}
            </div>

            <div className="jc-field">
              <label className="jc-label">
                Create Password <span className="jc-required">*</span>
              </label>
              {/* <input
                className={`jc-input ${errors.password ? "jc-input-error" : ""}`}
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Create your password"
              /> */}

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  className={`jc-input ${errors.password ? "jc-input-error" : ""}`}
                  placeholder="Create your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <line
                        x1="1"
                        y1="1"
                        x2="23"
                        y2="23"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              </div>
              {errors.password && <p className="jc-error">{errors.password}</p>}
            </div>

            {/* Professional Details */}
            <h2 className="jc-section-title">Professional Details</h2>

            <div className="jc-field">
              <label className="jc-label">
                Languages Known <span className="jc-required">*</span>
              </label>

              <Select
                isMulti
                options={languageOptions}
                value={selectedLanguages}
                onChange={handleLanguageChange}
                placeholder="Enter Languages you speak"

                classNamePrefix="jc-select"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: "#faf7fc",
                    borderColor: errors.languageId ? "#ef4444" : "#dbcfe8",
                    minHeight: "44px",
                    boxShadow: state.isFocused
                      ? `0 0 0 3px rgba(168, 85, 247, 0.15)`
                      : "none",
                  }),
                }}
              />
              {errors.languageId && (
                <p className="jc-error">{errors.languageId}</p>
              )}
            </div>

            {/* Social */}
            <h2 className="jc-section-title">Social Media Details</h2>

            <div className="jc-field">
              <label className="jc-label">YouTube Link</label>
              <input
                className={`jc-input ${errors.youtubeLink ? "jc-input-error" : ""}`}
                name="youtubeLink"
                value={formData.youtubeLink}
                onChange={handleChange}
                placeholder="Enter your Social Media Link"
              />
            </div>

            <div className="jc-field">
              <label className="jc-label">Instagram Link</label>
              <input
                className={`jc-input ${errors.instagramLink ? "jc-input-error" : ""}`}
                name="instagramLink"
                value={formData.instagramLink}
                onChange={handleChange}
                placeholder="Enter your Social Media Link"
              />
            </div>

            <button type="submit" className="jc-btn" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit Application"}
            </button>
            {/* {errors.api && <p className="jc-error">{errors.api}</p>} */}
          </form>
        </div>

        {/* OTP MODAL */}
        {showOtp && (
          <OtpModal
            type={showOtp === "mobile" ? "mobile number" : "email id"}
            value={
              showOtp === "mobile" ? formData.mobileNumber : formData.email
            }
            onVerify={(otpCode) => {
              if (showOtp === "mobile") {
                verifyMobileOtp(otpCode);
              } else if (showOtp === "email") {
                verifyEmailOtp(otpCode);
              }
            }}
            onClose={() => setShowOtp(null)}
            setOtpError={setOtpError}
            otpError={otpError}
            onResend={
              showOtp === "mobile"
                ? handleMobileVerification
                : handleEmailVerification
            }
            resending={
              showOtp === "mobile" ? sendingMobileOtp : sendingEmailOtp
            }
          />
        )}

        {submitting && <Loader />}

        {/* SUCCESS MODAL */}
        {successMessage && (
          <SuccessModal
            SuccessMsg={successMessage}
            message={successDesc}
            notifyMsg={notifyMsg}
            btnName={btnName}
            onClose={handleClose}
          />
        )}
      </div>
    </>
  );
};

export default JoinCreatorForm;
